import { render, staticRenderFns } from "./WallsIo.vue?vue&type=template&id=6e1d8368&"
import script from "./WallsIo.vue?vue&type=script&lang=js&"
export * from "./WallsIo.vue?vue&type=script&lang=js&"
import style0 from "./WallsIo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports